import { render } from "./AboutView.vue?vue&type=template&id=d0f1e35c&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=d0f1e35c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f1e35c"]])

export default __exports__